import { render, staticRenderFns } from "./BranchComponent.vue?vue&type=template&id=d9f1ef12&scoped=true"
import script from "./BranchComponent.vue?vue&type=script&lang=js"
export * from "./BranchComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f1ef12",
  null
  
)

export default component.exports